import BrokerHeroImage from '@images/use-cases/BrokerHeroImage.webp';
import FmosHeroImage from '@images/use-cases/FmosImage.webp';
import GeneralAgentsHeroImage from '@images/use-cases/GasImage.webp';
import TpasHeroImage from '@images/use-cases/TpasImage.webp';
import PeosHeroImage from '@images/use-cases/PeosImage.webp';
import type { StaticImageData } from 'next/image';

export type UseCaseExploreSlug =
    | 'brokers'
    | 'fmos'
    | 'general-agents'
    | 'tpas'
    | 'peos';

export type UseCaseExploreItem = {
    slug: UseCaseExploreSlug;
    title: string;
    description: string;
    href: string;
    image: StaticImageData | string;
    imageAlt: string;
};

export const USE_CASES_EXPLORE_ITEMS: UseCaseExploreItem[] = [
    {
        slug: 'brokers',
        title: 'Brokers',
        description:
            'Brokers face growing pressure to deliver flexible, cost-effective benefits while staying competitive. With ICHRA, you can offer tailored solutions that meet employer needs without the limitations of traditional group plans. Close more deals, reduce friction in plan selection, and provide long-term value to your clients.',
        href: '/use-cases/brokers',
        image: BrokerHeroImage,
        imageAlt: 'Brokers use case',
    },
    {
        slug: 'fmos',
        title: 'FMOs',
        description:
            'FMOs can accelerate growth by equipping brokers with innovative products like ICHRA. Predictable Benefits provides the infrastructure to scale distribution, support brokers with modern tools, and expand into new market segments. Drive adoption across your network while maintaining operational simplicity.',
        href: '/use-cases/fmos',
        image: FmosHeroImage,
        imageAlt: 'FMOs use case',
    },
    {
        slug: 'general-agents',
        title: 'General Agents (GAs)',
        description:
            'General Agents are increasingly being bypassed by direct-to-broker and direct-to-employer solutions. Predictable Benefits enables you to stay central by offering a fully branded ICHRA platform to your broker network. Maintain control, strengthen relationships, and unlock new revenue streams without rebuilding your infrastructure.',
        href: '/use-cases/general-agents',
        image: GeneralAgentsHeroImage,
        imageAlt: 'General Agents use case',
    },
    {
        slug: 'tpas',
        title: 'TPAs',
        description:
            'TPAs are responsible for managing complex benefits operations at scale. With Predictable Benefits, you can automate key workflows, reduce manual effort, and support ICHRA plans efficiently across multiple employers. Ensure compliance, improve operational efficiency, and deliver a better experience for your clients.',
        href: '/use-cases/tpas-third-party-administrators',
        image: TpasHeroImage,
        imageAlt: 'TPAs use case',
    },
    {
        slug: 'peos',
        title: 'PEOs',
        description:
            'Traditional PEO models struggle with high-loss clients and rising renewal costs. ICHRA allows you to pivot these clients instead of losing them—offering flexible benefits without taking on additional risk. Strengthen retention, open new revenue opportunities, and modernize your benefits strategy.',
        href: '/use-cases/peos-payroll-employment-organizations',
        image: PeosHeroImage,
        imageAlt: 'PEOs use case',
    },
];
